import androidIcon from "../../assets/img/icons/platform_android.svg";
import iosIcon from "../../assets/img/icons/platform_ios.svg";
import linuxIcon from "../../assets/img/icons/platform_linux.svg";
import windowsIcon from "../../assets/img/icons/platform_windows.svg";
import type { Vpn } from "../../types";

interface PlatformSupportIconsProps {
  vpn: Vpn;
  className?: string;
}

function PlatformSupportIcons({ vpn, className }: PlatformSupportIconsProps) {
  const { supports_windows, supports_android, supports_ios, supports_linux } =
    vpn;

  const supportsSomething =
    supports_windows || supports_android || supports_ios || supports_linux;

  if (!supportsSomething) {
    return null;
  }

  return (
    <div className={`${className}`}>
      {supports_windows && (
        <div className="p-[0.625rem] inline-block">
          <img src={windowsIcon} alt="Windows" className="w-[1.25rem] h-auto" />
        </div>
      )}
      {supports_android && (
        <div className="p-[0.625rem] inline-block">
          <img src={androidIcon} alt="Android" className="w-[1.25rem] h-auto" />
        </div>
      )}
      {supports_ios && (
        <div className="p-[0.625rem] inline-block">
          <img src={iosIcon} alt="iOS" className="w-[1.25rem] h-auto" />
        </div>
      )}
      {supports_linux && (
        <div className="p-[0.625rem] inline-block">
          <img src={linuxIcon} alt="Linux" className="w-[1.25rem] h-auto" />
        </div>
      )}
    </div>
  );
}

export default PlatformSupportIcons;
